import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class IcecreamBadge extends WritingBadge {
  public readonly id = BadgeId.icecream;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.pagesCount >= 300;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/icecream.ts